import { DashboardAlertSetting } from '../entities/DashboardAlert';

/**
 * ダッシュボードアラート設定を作成するファクトリークラス
 */
export class DashboardAlertSettingFactory {
  /**
   * DashboardAlertSettingを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<DashboardAlertSetting> = {}): DashboardAlertSetting => {
    const dashboardAlertSetting: DashboardAlertSetting = {
      critical: {
        excess: {
          consecutiveMonths: initialData.critical?.excess?.consecutiveMonths ?? '',
          ratioThreshold: initialData.critical?.excess?.ratioThreshold ?? '',
          momChangeRateThreshold: initialData.critical?.excess?.momChangeRateThreshold ?? '',
          minQuantityThreshold: initialData.critical?.excess?.minQuantityThreshold ?? '',
        },
        shortage: {
          consecutiveMonths: initialData.critical?.shortage?.consecutiveMonths ?? '',
          ratioThreshold: initialData.critical?.shortage?.ratioThreshold ?? '',
          momChangeRateThreshold: initialData.critical?.shortage?.momChangeRateThreshold ?? '',
          minQuantityThreshold: initialData.critical?.shortage?.minQuantityThreshold ?? '',
          currentMonthForecastAccuracyThreshold: initialData.critical?.shortage?.currentMonthForecastAccuracyThreshold ?? '',
        },
      },
      warning: {
        excess: {
          consecutiveMonths: initialData.warning?.excess?.consecutiveMonths ?? '',
          ratioThreshold: initialData.warning?.excess?.ratioThreshold ?? '',
          momChangeRateThreshold: initialData.warning?.excess?.momChangeRateThreshold ?? '',
          minQuantityThreshold: initialData.warning?.excess?.minQuantityThreshold ?? '',
        },
        shortage: {
          consecutiveMonths: initialData.warning?.shortage?.consecutiveMonths ?? '',
          ratioThreshold: initialData.warning?.shortage?.ratioThreshold ?? '',
          momChangeRateThreshold: initialData.warning?.shortage?.momChangeRateThreshold ?? '',
          minQuantityThreshold: initialData.warning?.shortage?.minQuantityThreshold ?? '',
        },
      },
    };
    return dashboardAlertSetting;
  };
}
